import { createFileRoute } from '@tanstack/react-router'
import { Hoje } from '@/features/hoje/Hoje'

/** Hoje: as sessões do dia, quem chegou, o que está pendente de cobrança. */
export const Route = createFileRoute('/_app/app/')({
  staticData: { crumb: { label: 'Hoje' } },
  component: Hoje,
})
